import { getTerms } from '@/calls/terms';

const terms = {
  namespaced: true,
  state: {
    requests: 0,
    item: null
  },
  mutations: {
    setItem(state, item) {
      state.item = item;
    },
    increaseRequests(state) {
      state.requests += 1;
    },
    decreaseRequests(state) {
      state.requests -= 1;
    }
  },
  actions: {
    async get({ commit }, locale) {
      commit('increaseRequests');
      try {
        const response = await getTerms(locale);
        commit('setItem', response);
      } catch (e) {
        commit('setItem', null);
      }
      commit('decreaseRequests');
    }
  }
};

export default terms;
